import { useContext } from "react";
import GlobalStateContext from "@/GlobalStateContext";

export function useGlobalState() {
    const ctx = useContext(GlobalStateContext);
    if (!ctx) {
        throw new Error("useGlobalState must be used within GlobalStateProvider");
    }
    return ctx;
}
